// extracted by mini-css-extract-plugin
module.exports = {"container":"SignIn__container___7FTKq darkPage__darkPage___HYDOP","logo":"SignIn__logo___L96BU logo__logo___oPoOM","content":"SignIn__content___RZSkY"};